import template from './service_option.html';
import controller from './service_option.controller';

let serviceOptionComponent = {
  restrict: 'E',
  bindings: {
    model: '=ngModel'
  },
  template,
  controller
};

export default serviceOptionComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/customer/common/service_options/service_option.component.js